(function(){
    'use strict'

    angular.module('app.vacacionesDetalle')
    .factory('VacacionesDetalleService', VacacionesDetalleService);

    VacacionesDetalleService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function VacacionesDetalleService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getByEmpleado: getByEmpleado,
            procesar: procesar,
            getPeriodos: getPeriodos
        };

        return api;

        function getPeriodos(){

            var url = apiSettings.apiBaseUrl + 'api/vacaciones-detalle/periodos/' + UserInfoService.getCompaniaId();
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };


        function getAll(tipoPlanillaId, periodo){

            var url = apiSettings.apiBaseUrl + 'api/vacaciones-detalle/' + UserInfoService.getCompaniaId() + '/' + tipoPlanillaId + '/' + periodo;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getByEmpleado(empleadoId){

            var url = apiSettings.apiBaseUrl + 'api/vacaciones-detalle/empleado/' + UserInfoService.getCompaniaId() + '/' + empleadoId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function procesar(parametrosProceso){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/vacaciones-detalle',  
                method: 'POST',  
                data: parametrosProceso
            });  
            return response;
        };

    };

})();